import Cookies from 'js-cookie';
import { PASSWORD_TOKEN, USER_EMAIL_TOKEN } from './userStorageConstants';

export function getUserEmailToken() {
    return Cookies.get(USER_EMAIL_TOKEN);
}

export function getPasswordToken() {
    return Cookies.get(PASSWORD_TOKEN);
}

export function removePasswordToken() {
    Cookies.remove(PASSWORD_TOKEN);
}
